import { ArrowUpRight, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-storystore-blue text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/1789bb12-3853-4a6f-85ed-b0a660e3bf2d.png" 
                alt="Story Store Logo" 
                className="h-8 mr-2" 
              />
              <span className="font-heading font-bold text-lg">STORY STORE</span>
            </div>
            
            <p className="text-white/80 mb-6 max-w-md">
              Story Store är en kreativ mediebyrå som hjälper företag och influencers att 
              förverkliga sin berättelse genom reklam, content och filmproduktion.
            </p>
            
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/storystore.se?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors">
                <span className="sr-only">Instagram</span>
                <Instagram size={18} />
              </a>
              <a href="https://www.tiktok.com/@storystore.se?is_from_webapp=1&sender_device=pc" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors">
                <span className="sr-only">TikTok</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/>
                  <path d="M16 8v8"/>
                  <path d="M12 16v4"/>
                  <path d="M20 10c0-4-1-7-6-7v8"/>
                </svg>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Snabblänkar</h3>
            <ul className="space-y-3">
              <li>
                <a href="#tjanster" className="text-white/80 hover:text-white transition-colors flex items-center">
                  Tjänster <ArrowUpRight size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-white/80 hover:text-white transition-colors flex items-center">
                  Portfolio <ArrowUpRight size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a href="#process" className="text-white/80 hover:text-white transition-colors flex items-center">
                  Process <ArrowUpRight size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a href="#om-oss" className="text-white/80 hover:text-white transition-colors flex items-center">
                  Om oss <ArrowUpRight size={14} className="ml-1" />
                </a>
              </li>
              <li>
                <a href="#kontakt" className="text-white/80 hover:text-white transition-colors flex items-center">
                  Kontakt <ArrowUpRight size={14} className="ml-1" />
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Kontakt</h3>
            <ul className="space-y-3 text-white/80">
              <li>
                <span className="block">Story Store AB</span>
              </li>
              <li>
                <span className="block">Stormbyvägen 2-4</span>
                <span className="block">163 55 Stockholm</span>
              </li>
              <li>
                <a href="tel:+46103333302" className="hover:text-white transition-colors">
                  010-333 33 02
                </a>
              </li>
              <li>
                <a href="mailto:info@story-store.se" className="hover:text-white transition-colors">
                  info@story-store.se
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Story Store AB. Alla rättigheter förbehållna.
          </p>
          
          <div className="flex flex-wrap gap-4 text-sm text-white/60">
            <a href="#" className="hover:text-white transition-colors">Integritetspolicy</a>
            <span>|</span>
            <a href="#" className="hover:text-white transition-colors">Användarvillkor</a>
            <span>|</span>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
